var map = {
	"./activity-details.svg": 814,
	"./activity-flag.svg": 69690,
	"./add-patient-success.svg": 63067,
	"./add-patient.svg": 61645,
	"./admin.svg": 48817,
	"./administration.svg": 32358,
	"./archived-users-directory.svg": 83467,
	"./arrow-simple-left.svg": 64448,
	"./arrow-simple-right.svg": 97039,
	"./assets.svg": 99263,
	"./att-current.svg": 43365,
	"./att-history.svg": 86674,
	"./audit-trail-logs.svg": 26086,
	"./body.svg": 73720,
	"./button-icon-save.svg": 88412,
	"./calendar.svg": 18190,
	"./calibration-off.svg": 14700,
	"./calibration-on.svg": 38038,
	"./callout-down.svg": 56129,
	"./callout.svg": 87488,
	"./ce_logo.svg": 57430,
	"./chevron-carousel-left.svg": 65386,
	"./chevron-carousel-right.svg": 15681,
	"./chevron-down.svg": 48994,
	"./chevron-left.svg": 1065,
	"./chevron-right.svg": 47892,
	"./chevron-up.svg": 75249,
	"./circle-warning.svg": 52411,
	"./close.svg": 82144,
	"./cog-hollow.svg": 29035,
	"./companion-logo.svg": 96730,
	"./compensation/bodyweighttransfer-left.svg": 78966,
	"./compensation/bodyweighttransfer-right.svg": 73173,
	"./compensation/leftkneeextension-up.svg": 59972,
	"./compensation/leftshoulderabductionadduction-left.svg": 77840,
	"./compensation/leftshoulderabductionadduction-right.svg": 73375,
	"./compensation/leftshoulderflexionextension-backward.svg": 9936,
	"./compensation/leftshoulderflexionextension-forward.svg": 60394,
	"./compensation/rightkneeextension-up.svg": 65779,
	"./compensation/rightshoulderabductionadduction-left.svg": 53405,
	"./compensation/rightshoulderabductionadduction-right.svg": 35008,
	"./compensation/rightshoulderflexionextension-backward.svg": 73365,
	"./compensation/rightshoulderflexionextension-forward.svg": 85941,
	"./compensation/trunkflexion-backward.svg": 10508,
	"./compensation/trunkflexion-forward.svg": 1902,
	"./compensation/trunkflexion-left.svg": 68440,
	"./compensation/trunkflexion-right.svg": 93287,
	"./compensation_flag_icons/elbow-left.svg": 55202,
	"./compensation_flag_icons/elbow-right.svg": 32249,
	"./compensation_flag_icons/head-center.svg": 60773,
	"./compensation_flag_icons/head-left.svg": 41965,
	"./compensation_flag_icons/head-right.svg": 34480,
	"./compensation_flag_icons/leg-left.svg": 98273,
	"./compensation_flag_icons/leg-right.svg": 47500,
	"./compensation_flag_icons/shoulder-left.svg": 84387,
	"./compensation_flag_icons/shoulder-right.svg": 20934,
	"./compensation_flag_icons/torso.svg": 53964,
	"./compensation_flag_icons/wrist-left.svg": 93810,
	"./compensation_flag_icons/wrist-right.svg": 66377,
	"./compensation_groups/bodyweighttransfer.svg": 47913,
	"./compensation_groups/leftkneeextension.svg": 38113,
	"./compensation_groups/leftshoulder.svg": 94063,
	"./compensation_groups/rightkneeextension.svg": 52126,
	"./compensation_groups/rightshoulder.svg": 96302,
	"./compensation_groups/trunkflexion.svg": 30455,
	"./consent.svg": 60898,
	"./contact-us.svg": 93085,
	"./copy.svg": 91131,
	"./create_program.svg": 79641,
	"./create_template.svg": 30457,
	"./credentials.svg": 98502,
	"./data-export.svg": 82715,
	"./day-period-afternoon.svg": 29775,
	"./day-period-morning.svg": 96387,
	"./demo-patient.svg": 55489,
	"./done-half.svg": 6098,
	"./done-invert-colors.svg": 24742,
	"./done-not-training.svg": 87591,
	"./done-not.svg": 22580,
	"./done-notassigned.svg": 86524,
	"./done-partially.svg": 5381,
	"./done-password-criteria.svg": 46980,
	"./done-rounded-circle-fill.svg": 15097,
	"./done-rounded-circle.svg": 54989,
	"./done.svg": 37820,
	"./dpo-admin.svg": 86061,
	"./drag-handle.svg": 75813,
	"./duplicate.svg": 17799,
	"./e-ifu.svg": 82304,
	"./edit.svg": 81640,
	"./email.svg": 16724,
	"./epro-patients.svg": 43677,
	"./european-representative.svg": 78151,
	"./export.svg": 74406,
	"./external.svg": 39273,
	"./faq.svg": 32228,
	"./feedback.svg": 42769,
	"./filter.svg": 36570,
	"./flags/ar-SA.svg": 23866,
	"./flags/de.svg": 77289,
	"./flags/es.svg": 39844,
	"./flags/fr.svg": 4576,
	"./flags/gb.svg": 51199,
	"./flags/it.svg": 74279,
	"./flags/ro.svg": 16345,
	"./flags/us.svg": 70516,
	"./general-details.svg": 32537,
	"./geolocalization.svg": 45476,
	"./globe.svg": 95899,
	"./hamburger.svg": 35273,
	"./hand.svg": 6199,
	"./help.svg": 15949,
	"./ifu.svg": 4534,
	"./import.svg": 13611,
	"./import_mm_template.svg": 63945,
	"./import_my_template.svg": 23173,
	"./info-circle.svg": 40909,
	"./level.svg": 39710,
	"./levels.svg": 51937,
	"./license.svg": 57781,
	"./loading.svg": 69736,
	"./logout.svg": 6590,
	"./manufacture-date.svg": 13172,
	"./manufacturer.svg": 42951,
	"./md.svg": 91071,
	"./medical-details.svg": 10944,
	"./menu.svg": 18001,
	"./mindmotion-logo.svg": 54610,
	"./mini-cam.svg": 17499,
	"./mini-mic.svg": 16807,
	"./mini-sound.svg": 49795,
	"./more-menu.svg": 80493,
	"./movement/ArmReaching.svg": 19931,
	"./movement/ArmReachingAndPalmarGrasping.svg": 67344,
	"./movement/ArmsPumping.svg": 73359,
	"./movement/BilateralStep.svg": 78936,
	"./movement/FingersPinch.svg": 74532,
	"./movement/ForearmPronationSupination.svg": 3958,
	"./movement/ForwardBackwardSteps.svg": 77083,
	"./movement/FreeSqueeze.svg": 46084,
	"./movement/FreeSqueezeAndFreeWristMovement.svg": 49749,
	"./movement/FreeSteps.svg": 15857,
	"./movement/FreeWristMovement.svg": 23158,
	"./movement/GripFlexionExtension.svg": 76282,
	"./movement/GripPronationSupination.svg": 78462,
	"./movement/GripRadialUlnarDeviation.svg": 48135,
	"./movement/HandGraspRelease.svg": 10853,
	"./movement/HorizontalArmReaching.svg": 83951,
	"./movement/HorizontalShoulderAbductionAdduction.svg": 69346,
	"./movement/LateralBodyWeightTransfer.svg": 33730,
	"./movement/LateralStep.svg": 18185,
	"./movement/PalmarGrasp.svg": 92456,
	"./movement/PincerGrasp.svg": 60288,
	"./movement/ShoulderAbduction.svg": 15311,
	"./movement/ShoulderAbductionAdduction.svg": 27718,
	"./movement/ShoulderFlexion.svg": 70851,
	"./movement/ShoulderFlexionExtension.svg": 58130,
	"./movement/Squat.svg": 59228,
	"./movement/SteeringWheel.svg": 25464,
	"./movement/SteeringWheelAndArmsPumping.svg": 83712,
	"./movement/TrunkAxialRotation.svg": 87501,
	"./movement/TrunkForwardBackwardFlexion.svg": 45813,
	"./movement/TrunkForwardBackwardLateralFlexion.svg": 47270,
	"./movement/TrunkLateralFlexion.svg": 35522,
	"./movement/UnilateralShoulderAbductionAdduction.svg": 19257,
	"./movement/UnilateralStep.svg": 271,
	"./movement/UpperLimbFlexionExtension.svg": 72098,
	"./movement/UpperLimbFlexionExtensionAndTrunkLateralFlexion.svg": 66835,
	"./movement/VerticalHandsReaching.svg": 21489,
	"./movement/WorldFootsteps.svg": 10943,
	"./movement/WristFlexionExtension.svg": 59611,
	"./movement/WristRadialUlnarDeviation.svg": 29733,
	"./my-patients.svg": 72665,
	"./notifications.svg": 56368,
	"./optional-features-def.svg": 35994,
	"./optional-features.svg": 78120,
	"./patient-details.svg": 4290,
	"./patient-recent.svg": 59961,
	"./patient.svg": 30231,
	"./patient_state/borg/borg-0.svg": 96572,
	"./patient_state/borg/borg-1.svg": 50845,
	"./patient_state/borg/borg-10.svg": 72839,
	"./patient_state/borg/borg-2.svg": 13022,
	"./patient_state/borg/borg-3.svg": 75599,
	"./patient_state/borg/borg-4.svg": 9712,
	"./patient_state/borg/borg-5.svg": 21953,
	"./patient_state/borg/borg-6.svg": 16914,
	"./patient_state/borg/borg-7.svg": 54851,
	"./patient_state/borg/borg-8.svg": 14772,
	"./patient_state/borg/borg-9.svg": 40405,
	"./patient_state/mood/bad.svg": 29457,
	"./patient_state/mood/good.svg": 67391,
	"./patient_state/mood/okay.svg": 1472,
	"./patient_state/mood/veryBad.svg": 7365,
	"./patient_state/mood/veryGood.svg": 15427,
	"./patient_state/skipped.svg": 9808,
	"./patients.svg": 86214,
	"./peripherals/Kinect.svg": 90732,
	"./peripherals/LeapMotion.svg": 82326,
	"./peripherals/MMB_1x.svg": 94610,
	"./peripherals/MMB_2x.svg": 99895,
	"./planner-calendar.svg": 18287,
	"./planner-calibrate.svg": 63564,
	"./planner-download.svg": 67505,
	"./planner-dropper.svg": 78839,
	"./planner-file.svg": 74483,
	"./planner-log.svg": 34261,
	"./planner-minus.svg": 37143,
	"./planner-options.svg": 10545,
	"./planner-plus.svg": 17913,
	"./planner-results.svg": 40293,
	"./planner-settings.svg": 69366,
	"./planner-trash.svg": 42033,
	"./play.svg": 62690,
	"./posture-seat.svg": 79190,
	"./posture-stand.svg": 33671,
	"./profile-admin.svg": 62977,
	"./profile-patient.svg": 28871,
	"./profile-patient_full.svg": 31693,
	"./profile-physician.svg": 13812,
	"./profile-sitemanager.svg": 65082,
	"./profile-sitemanager_full.svg": 282,
	"./profile-support.svg": 89937,
	"./profile-therapist.svg": 55462,
	"./profile-therapist_full.svg": 24262,
	"./random.svg": 24881,
	"./ref.svg": 67464,
	"./reload.svg": 40571,
	"./save_as_template.svg": 6379,
	"./search.svg": 41792,
	"./session-scheduled.svg": 46554,
	"./settings-light.svg": 27624,
	"./settings.svg": 4763,
	"./sidebar-close.svg": 80223,
	"./sidebar-open.svg": 20769,
	"./site-management.svg": 50351,
	"./site-managers.svg": 94582,
	"./sort.svg": 77960,
	"./sort_asc.svg": 61558,
	"./sort_desc.svg": 15984,
	"./star.svg": 81508,
	"./stop.svg": 44084,
	"./swissMadeSoftware.svg": 40365,
	"./teleconsultation.svg": 28003,
	"./templates-directory.svg": 35143,
	"./templates-editor.svg": 90485,
	"./therapeutic-goal.svg": 40512,
	"./therapist-details.svg": 12239,
	"./therapists.svg": 79657,
	"./tick.svg": 94411,
	"./time-zone.svg": 91090,
	"./timeline-session-extra-training.svg": 18726,
	"./timeline-session-missed.svg": 92544,
	"./timeline-session-supervised.svg": 40617,
	"./timeline-session-unsupervised.svg": 90692,
	"./top-menu-live-meeting-down.svg": 64067,
	"./top-menu-live-meeting-up.svg": 46396,
	"./top-menu-patients-directory-down.svg": 921,
	"./top-menu-patients-directory-up.svg": 81686,
	"./top-menu-telerehab-down.svg": 41289,
	"./top-menu-telerehab-up.svg": 89126,
	"./trained_functions/FunctionAll.svg": 99580,
	"./trained_functions/FunctionHandBilateral.svg": 1791,
	"./trained_functions/FunctionHandLeft.svg": 58974,
	"./trained_functions/FunctionHandRight.svg": 12029,
	"./trained_functions/FunctionLowerLimbBilateral.svg": 20607,
	"./trained_functions/FunctionLowerLimbLeft.svg": 26814,
	"./trained_functions/FunctionLowerLimbRight.svg": 33277,
	"./trained_functions/FunctionNone.svg": 62716,
	"./trained_functions/FunctionTrunkBilateral.svg": 92040,
	"./trained_functions/FunctionTrunkLeft.svg": 29639,
	"./trained_functions/FunctionTrunkRight.svg": 29378,
	"./trained_functions/FunctionUpperLimbBilateral.svg": 87134,
	"./trained_functions/FunctionUpperLimbLeft.svg": 76701,
	"./trained_functions/FunctionUpperLimbRight.svg": 56576,
	"./training-plan.svg": 29102,
	"./training_materials/next.svg": 3227,
	"./training_materials/previous.svg": 51151,
	"./training_materials/tm-completed-video.svg": 33743,
	"./training_materials/tm-new-video.svg": 53458,
	"./training_materials/training-material.svg": 15844,
	"./undo.svg": 12006,
	"./unknown.svg": 72858,
	"./unsupervised-training.svg": 28418,
	"./user-sessions.svg": 24377,
	"./videomeeting-mic-off.svg": 53454,
	"./videomeeting-mic-on.svg": 81080,
	"./videomeeting-sound-off.svg": 23514,
	"./videomeeting-sound-on.svg": 19428,
	"./videomeeting-video-off.svg": 73510,
	"./videomeeting-video-on.svg": 1712,
	"./visibility-hide.svg": 1157,
	"./visibility-show.svg": 36982,
	"./warning-circle.svg": 95869,
	"./warning.svg": 63632
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46669;